import { useEffect, useState } from 'react';
import { injectJsonLd } from '@/utils/seo';

const faqs = [
  {
    q: '瓜迹的事件时间轴多久更新一次？',
    a: '针对正在发酵的事件，瓜迹通常以小时级为单位跟踪进展，出现新的官方回应、当事人声明或重要转折时，会第一时间补充对应节点，并在栏目内标记更新时间。',
  },
  {
    q: '事件出现新进展时，节点会如何补充？',
    a: '编辑会把新进展拆解为一个独立节点，标注发生日期与“进展/后续”等阶段标签，插入到时间轴末尾，同时更新该事件的“最新节点”与热度信息，保证追更不断线。',
  },
  {
    q: '时间轴上的信息是否经过核实？',
    a: '瓜迹坚持“多源交叉核验”原则：优先采用官方通稿、当事人回应与权威媒体报道，对仅靠匿名爆料、无法证实的传闻会明确标注，避免把猜测写成既定事实。',
  },
  {
    q: '我能为某起事件提供线索或纠正错误吗？',
    a: '当然可以。如果你掌握公开可查的新线索，或发现时间轴中有疏漏，欢迎通过页面底部的邮箱联系我们，编辑核实后会及时补全或更正对应节点。',
  },
];

const ld = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

export default function FaqSection() {
  const [open, setOpen] = useState(0);

  useEffect(() => {
    const cleanup = injectJsonLd(ld);
    return cleanup;
  }, []);

  return (
    <section className="mx-auto max-w-4xl px-4 py-12 md:px-6 md:py-16">
      <div className="text-center">
        <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-wide text-primary-600">
          <i className="ri-question-line" /> 常见问题
        </span>
        <h2 className="mt-2 font-heading text-2xl font-semibold text-foreground-950 md:text-3xl">关于吃瓜时间轴，你可能想问</h2>
      </div>

      <div className="mt-8 space-y-3">
        {faqs.map((f, i) => {
          const isOpen = open === i;
          return (
            <div key={f.q} className="overflow-hidden rounded-xl border border-background-200 bg-background-50">
              <button
                type="button"
                onClick={() => setOpen(isOpen ? -1 : i)}
                aria-expanded={isOpen}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
              >
                <h3 className="flex items-center gap-3 text-sm font-semibold text-foreground-900 md:text-base">
                  <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold tabular-nums ${isOpen ? 'bg-primary-500 text-background-50' : 'bg-secondary-100 text-secondary-700'}`}>
                    Q{i + 1}
                  </span>
                  {f.q}
                </h3>
                <i className={`shrink-0 text-lg text-foreground-400 transition-transform ${isOpen ? 'rotate-45' : ''} ri-add-line`} />
              </button>
              {isOpen && (
                <div className="border-t border-background-200 px-5 pb-5 pt-4 md:pl-14">
                  <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}